import { render, staticRenderFns } from "./constructionSimulation.html?vue&type=template&id=2c5a14b4&scoped=true&lang=html&external"
import script from "./constructionSimulation.js?vue&type=script&lang=js&external"
export * from "./constructionSimulation.js?vue&type=script&lang=js&external"
import style0 from "./constructionSimulation.scss?vue&type=style&index=0&id=2c5a14b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a14b4",
  null
  
)

export default component.exports